'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var iconConfig = [{
	name: 'iconNext',
	inputType: 'icon',
	label: 'Choose next icon',
	default: false
}, {
	name: 'iconNextSize',
	inputType: 'text',
	label: 'Set size on next icon',
	default: '2em'
}, {
	name: 'iconNextColor',
	inputType: 'color',
	label: 'Set color on next icon',
	default: '#000'
}, {
	name: 'iconPrev',
	inputType: 'icon',
	label: 'Choose previous icon',
	default: false
}, {
	name: 'iconPrevSize',
	inputType: 'text',
	label: 'Set size on previous icon',
	default: '2em'
}, {
	name: 'iconPrevColor',
	inputType: 'color',
	label: 'Set color on previous icon',
	default: '#000'
}];

var imageConfig = [{
	name: 'imageNext',
	inputType: 'media',
	label: 'Choose next image',
	default: ''
}, {
	name: 'imagePrev',
	inputType: 'media',
	label: 'Choose previous image',
	default: ''
}];

var conditionallyAddConfig = function conditionallyAddConfig(node, conditionStr, configArray) {
	return node && node.props.type === conditionStr ? configArray : [];
};

exports.default = function (node) {
	return {
		type: 'SLIDER_01',
		name: 'Slideshow',
		allowedSections: ['footer', 'header', 'main'],
		disallowedChildren: ['CELL_01', 'MAIN_NAVIGATION_*'],
		category: 'Media',
		props: [{
			name: 'play',
			inputType: 'checkbox',
			label: 'Autoplay',
			default: false
		}, {
			name: 'loop',
			inputType: 'checkbox',
			label: 'Loop',
			default: false
		}, {
			name: 'speed',
			inputType: 'text',
			label: 'Animation speed',
			default: '500'
		}, {
			name: 'duration',
			inputType: 'text',
			label: 'Animation duration',
			default: '3000'
		}, {
			name: 'effect',
			inputType: 'select',
			label: 'Effect',
			default: 'slide',
			values: [{
				label: 'Slide',
				value: 'slide'
			}, {
				label: 'Fade',
				value: 'fade'
			}, {
				label: 'cube',
				value: 'cube'
			}, {
				label: 'Coverflow (Needs fixed height)',
				value: 'coverflow'
			}, {
				label: 'Flip',
				value: 'flip'
			}]
		}, {
			name: 'timing',
			inputType: 'select',
			label: 'Transition',
			default: 'ease',
			values: [{
				label: 'Linear',
				value: 'linear'
			}, {
				label: 'Ease',
				value: 'ease'
			}, {
				label: 'Ease-in',
				value: 'ease-in'
			}, {
				label: 'Ease-out',
				value: 'ease-out'
			}, {
				label: 'Ease-in-out',
				value: 'ease-in-out'
			}]
		}],
		hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
			label: 'Navigation',
			props: [{
				name: 'arrows',
				inputType: 'checkbox',
				label: 'Show Arrows',
				default: true
			}, {
				name: 'type',
				inputType: 'select',
				label: 'Choose arrow type',
				default: 'none',
				values: [{
					label: 'Native',
					value: 'none'
				}, {
					label: 'Icon',
					value: 'icon'
				}, {
					label: 'Image',
					value: 'image'
				}]
			}].concat(_toConsumableArray(conditionallyAddConfig(node, 'icon', iconConfig)), _toConsumableArray(conditionallyAddConfig(node, 'image', imageConfig)), [{
				name: 'pagination',
				inputType: 'checkbox',
				label: 'Show Pagination',
				default: true
			}, {
				name: 'paginationType',
				inputType: 'select',
				label: 'Choose pagination type',
				default: 'bullets',
				values: [{
					label: 'Bullets',
					value: 'bullets'
				}, {
					label: 'Fraction',
					value: 'fraction'
				}]
			}])
		}, {
			label: 'Slide options mobile',
			props: [{
				name: 'slidesPerViewMobile',
				inputType: 'select',
				label: 'Slides per view',
				default: '1',
				values: ['1', '2', '3', '4']
			}, {
				name: 'slidesPerColumnMobile',
				inputType: 'select',
				label: 'Slides per column',
				default: '1',
				values: ['1', '2', '3', '4']
			}, {
				name: 'slidesPerGroupMobile',
				inputType: 'select',
				label: 'Slides per group',
				default: '1',
				values: ['1', '2', '3', '4']
			}, {
				name: 'spaceBetweenMobile',
				inputType: 'select',
				label: 'Space between',
				default: '0',
				values: ['0', '10', '20', '30', '40', '50']
			}, {
				name: 'centerSlidesMobile',
				inputType: 'checkbox',
				label: 'Center slides',
				default: false
			}]
		}, {
			'label': 'Slide options tablet',
			'props': [{
				'name': 'slidesPerViewTablet',
				'inputType': 'select',
				'label': 'Slides per view',
				'default': '1',
				'values': ['1', '2', '3', '4']
			}, {
				'name': 'slidesPerColumnTablet',
				'inputType': 'select',
				'label': 'Slides per column',
				'default': '1',
				'values': ['1', '2', '3', '4']
			}, {
				name: 'slidesPerGroupTablet',
				inputType: 'select',
				label: 'Slides per group',
				default: '1',
				values: ['1', '2', '3', '4']
			}, {
				'name': 'spaceBetweenTablet',
				'inputType': 'select',
				'label': 'Space between',
				'default': '0',
				'values': ['0', '10', '20', '30', '40', '50']
			}, {
				'name': 'centerSlidesTablet',
				'inputType': 'checkbox',
				'label': 'Center slides',
				'default': false
			}]
		}, {
			'label': 'Slide options desktop',
			'props': [{
				'name': 'slidesPerViewDesktop',
				'inputType': 'select',
				'label': 'Slides per view',
				'default': '1',
				'values': ['1', '2', '3', '4']
			}, {
				'name': 'slidesPerColumnDesktop',
				'inputType': 'select',
				'label': 'Slides per column',
				'default': '1',
				'values': ['1', '2', '3', '4']
			}, {
				name: 'slidesPerGroupDesktop',
				inputType: 'select',
				label: 'Slides per group',
				default: '1',
				values: ['1', '2', '3', '4']
			}, {
				'name': 'spaceBetweenDesktop',
				'inputType': 'select',
				'label': 'Space between',
				'default': '0',
				'values': ['0', '10', '20', '30', '40', '50']
			}, {
				'name': 'centerSlidesDesktop',
				'inputType': 'checkbox',
				'label': 'Center slides',
				'default': false
			}]
		}, {
			'label': 'Advanced options',
			'props': [{
				name: 'direction',
				inputType: 'select',
				label: 'Direction (Needs fixed height)',
				default: 'horizontal',
				values: [{
					label: 'Horizontal',
					value: 'horizontal'
				}, {
					label: 'Vertical',
					value: 'vertical'
				}]
			}, {
				name: 'disableOnInteraction',
				inputType: 'checkbox',
				label: 'Stop autoplay on user interaction',
				default: false
			}, {
				name: 'maintenance',
				inputType: 'checkbox',
				label: 'Set slideshow in maintenance mode',
				default: false
			}, {
				name: 'roundLengths',
				inputType: 'checkbox',
				label: 'Prevent blurry texts on usual resolution screens',
				default: true
			}]
		})
	};
};